import React, { useState } from 'react';
import { AiFillMinusCircle } from 'react-icons/ai';

type PropsIconAdd = {
  tooltipMessage?: string
  size?: number
  cursor?: boolean
  color?: "text-primary" | "text-warning" | "text-danger" | "red"
  mouseOver?: boolean
}

export function IconRemove({
  cursor, size, tooltipMessage, color, mouseOver,
}:PropsIconAdd) {
  const [over, setOver] = useState(false);

  function handleSetOver() {
    setOver(!over);
  }
  return (
    <div
      data-tip={tooltipMessage || ""}
      onMouseEnter={mouseOver ? handleSetOver : undefined}
      onMouseLeave={mouseOver ? handleSetOver : undefined}
    >
      <AiFillMinusCircle
        className={mouseOver ? (over ? color : undefined) : (color || undefined)}
        size={size || 30}
        cursor={cursor ? "pointer" : undefined}
      />
    </div>
  );
}
